import { Dtos, SuretyAccountId } from "@inrev/common";
import { AdminAccountIndemnitySummary } from "@portal/api/account/admin";
import { IndemnityAgreementNotification } from "@portal/components/indemnity-agreement";
import { Card } from "@portal/components/primitives";
import { FC } from "react";
import { AdminAccountCreateIndemnityAgreement } from "./AdminAccountCreateIndemnityAgreement";
import { AdminAccountIndemnitorSignatureStatusList } from "./AdminAccountIndemnitorSignatureStatusList";
import { AdminAccountIndemnityAgreementFileUpload } from "./AdminAccountIndemnityAgreementFileUpload";

export type AdminAccountIndemnityAgreementDetailsProps = {
	accountId: SuretyAccountId;
	indemnitySummary: AdminAccountIndemnitySummary;
	latestIndemnityAgreement: Dtos.SuretyAccount.IndemnityAgreement.Get.Response | null;
	blockedOnAddress?: boolean;
};

export const AdminAccountIndemnityAgreementDetails: FC<
	AdminAccountIndemnityAgreementDetailsProps
> = ({ accountId, indemnitySummary, latestIndemnityAgreement, blockedOnAddress }) => {
	return (
		<div className="flex flex-col space-y-[10px] w-full auto-rows-min">
			{latestIndemnityAgreement ? (
				<>
					<IndemnityAgreementNotification
						status={latestIndemnityAgreement.status}
						signatureMethod={latestIndemnityAgreement.signatureMethod}
					/>
					<Card elevation="raised" data-testid="admin-account-signature-list">
						<Card.Body className="flex flex-col space-y-[20px] px-[15px] py-[10px] pb-[20px]">
							<AdminAccountIndemnitorSignatureStatusList
								indemnityAgreement={latestIndemnityAgreement}
							/>
							<div
								data-testid="admin-account-indemnity-upload"
								className="flex flex-col items-end space-y-[20px]"
							>
								<AdminAccountIndemnityAgreementFileUpload
									suretyAccountId={accountId}
									indemnityAgreementId={latestIndemnityAgreement.id}
									indemnityAgreementStatus={latestIndemnityAgreement.status}
								/>
							</div>
						</Card.Body>
					</Card>
				</>
			) : (
				<AdminAccountCreateIndemnityAgreement
					accountId={accountId}
					indemnitySummary={indemnitySummary}
					blockedOnAddress={blockedOnAddress}
				/>
			)}
		</div>
	);
};
